// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Which type of Modbus read operation to perform.
 */
export enum ModbusReadType {
  ReadHoldingRegisters = 0,
  ReadCoils = 1,
  ReadDiscreteInputs = 2,
  ReadInputRegisters = 3,
}
